<template>
  <div class="loading-page">
    <div class="loading-page__aurora"></div>
    <div class="loading-page__grid"></div>
    <div class="loading-page__orb loading-page__orb--left"></div>
    <div class="loading-page__orb loading-page__orb--right"></div>

    <div class="loading-page__card">
      <!-- 顶部品牌区域 -->
      <div class="loading-card__header">
        <div class="loading-card__badge">
          <span></span>
          ZQSX MANAGEMENT PLATFORM
        </div>
        <h2>政企实训</h2>
        <p>正在加载系统配置</p>
      </div>

      <!-- 加载动画区域 -->
      <div class="loading-card__body">
        <div class="loader">
          <div class="loader-ring loader-ring--1"></div>
          <div class="loader-ring loader-ring--2"></div>
          <div class="loader-ring loader-ring--3"></div>
          <div class="loader-core"></div>
        </div>

        <!-- 状态文字 -->
        <transition name="loading-fade" mode="out-in">
          <div :key="statusText" class="loading-status">
            <i :class="statusIcon" class="loading-status__icon"></i>
            <span>{{ statusText }}</span>
          </div>
        </transition>

        <!-- 进度条 -->
        <div class="loading-progress">
          <div class="loading-progress__bar">
            <div class="loading-progress__fill" :style="{ width: progress + '%' }"></div>
          </div>
          <span class="loading-progress__text">{{ Math.round(progress) }}%</span>
        </div>

        <!-- 无权限提示 -->
        <transition name="loading-fade">
          <div v-if="showError" class="loading-error">
            <i class="el-icon-warning-outline"></i>
            <p>{{ errorMessage }}</p>
            <el-button type="primary" size="small" @click="goBack">返回登录</el-button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingPage',
  data () {
    return {
      progress: 0,
      statusIndex: 0,
      showError: false,
      errorMessage: '',
      statusTexts: [
        '正在验证登录状态...',
        '正在获取用户信息...',
        '正在初始化系统...',
        '即将进入系统...'
      ],
      statusIcons: [
        'el-icon-user',
        'el-icon-key',
        'el-icon-setting',
        'el-icon-check'
      ]
    }
  },
  computed: {
    statusText () { return this.statusTexts[this.statusIndex] },
    statusIcon () { return this.statusIcons[this.statusIndex] }
  },
  created () {
    const token = this.$store.state.user.token
    if (!token) {
      this.$router.replace('/login')
      return
    }
    this.startLoading()
  },
  methods: {
    async startLoading () {
      const progressTimer = setInterval(() => {
        if (this.progress < 85) this.progress += Math.random() * 8
      }, 200)

      const statusTimer = setInterval(() => {
        if (this.statusIndex < this.statusTexts.length - 1) this.statusIndex++
      }, 500)

      try {
        // 拉取最新用户信息
        const userInfo = await this.$store.dispatch('user/refreshUserInfo')
        // 根据用户岗位过滤菜单
        this.$store.dispatch('permission/generateMenu', userInfo)

        clearInterval(progressTimer)
        clearInterval(statusTimer)
        this.progress = 100
        this.statusIndex = this.statusTexts.length - 1

        // 按岗位跳转默认首页：
        // 系统管理员(1) → 用户管理；项目管理员(2) → 模块管理(内容管理)
        const zauPost = userInfo && userInfo.zauPost
        const homePath = zauPost === 1 ? '/auth-user/list' : '/model-manage/list'
        setTimeout(() => {
          this.$router.replace(homePath)
        }, 400)
      } catch (error) {
        clearInterval(progressTimer)
        clearInterval(statusTimer)
        this.showError = true
        this.errorMessage = '获取用户信息失败，请重新登录'
        setTimeout(() => {
          this.$store.dispatch('user/logout')
          this.$router.replace('/login')
        }, 2000)
      }
    },

    goBack () {
      this.$store.dispatch('user/logout')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-page {
  position: relative; min-height: 100vh; display: flex; align-items: center; justify-content: center;
  overflow: hidden; padding: 40px 28px;
  background:
    radial-gradient(circle at 14% 18%, rgba(26, 54, 93, 0.22), transparent 24%),
    radial-gradient(circle at 88% 16%, rgba(56, 161, 105, 0.18), transparent 20%),
    radial-gradient(circle at 50% 110%, rgba(26, 54, 93, 0.12), transparent 28%),
    linear-gradient(135deg, #f8fbfd 0%, #edf4f8 42%, #e6f0f4 100%);
}

.loading-page__aurora, .loading-page__grid, .loading-page__orb { position: absolute; pointer-events: none; }

.loading-page__aurora {
  inset: -12% -10% auto; height: 420px;
  background:
    radial-gradient(circle at 18% 40%, rgba(26, 54, 93, 0.18), transparent 32%),
    radial-gradient(circle at 50% 12%, rgba(255, 255, 255, 0.7), transparent 28%),
    radial-gradient(circle at 82% 30%, rgba(56, 161, 105, 0.16), transparent 30%);
  filter: blur(14px); opacity: 0.95;
}

.loading-page__grid {
  inset: 0;
  background-image:
    linear-gradient(rgba(26, 54, 93, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(26, 54, 93, 0.05) 1px, transparent 1px);
  background-size: 34px 34px; mask-image: radial-gradient(circle at center, #000 42%, transparent 86%); opacity: 0.8;
}

.loading-page__orb { border-radius: 50%; filter: blur(12px); }
.loading-page__orb--left { width: 320px; height: 320px; left: -80px; top: 90px; background: radial-gradient(circle, rgba(26, 54, 93, 0.22), transparent 68%); }
.loading-page__orb--right { width: 280px; height: 280px; right: -30px; bottom: 40px; background: radial-gradient(circle, rgba(56, 161, 105, 0.18), transparent 70%); }

.loading-page__card {
  position: relative; z-index: 1; width: 420px; max-width: 100%; overflow: hidden;
  border: 1px solid rgba(117, 145, 173, 0.18); border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.78));
  box-shadow: 0 30px 70px rgba(38, 64, 92, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(18px);
}

.loading-card__header {
  padding: 32px 30px 20px; text-align: center;
  background: linear-gradient(135deg, rgba(26, 54, 93, 0.06), rgba(56, 161, 105, 0.04));
  border-bottom: 1px solid rgba(26, 54, 93, 0.08);
}

.loading-card__badge {
  display: inline-flex; align-items: center; gap: 10px; padding: 8px 16px;
  border: 1px solid rgba(26, 54, 93, 0.16); border-radius: 999px;
  background: rgba(255, 255, 255, 0.62); color: #42617f; font-size: 11px; letter-spacing: 0.16em; margin-bottom: 16px;
}

.loading-card__badge span {
  width: 8px; height: 8px; border-radius: 50%; background: #38a169;
  box-shadow: 0 0 16px rgba(56, 161, 105, 0.58); animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse { 0%, 100% { opacity: 0.6; transform: scale(0.9); } 50% { opacity: 1; transform: scale(1.1); } }

.loading-card__header h2 { margin: 0 0 8px; font-size: 24px; font-weight: 600; color: #243447; }
.loading-card__header p { margin: 0; font-size: 14px; color: rgba(53, 80, 108, 0.72); }

.loading-card__body { padding: 30px; display: flex; flex-direction: column; align-items: center; gap: 24px; }

.loader { position: relative; width: 100px; height: 100px; }
.loader-ring { position: absolute; inset: 0; border: 3px solid transparent; border-radius: 50%; }
.loader-ring--1 { border-top-color: rgba(26, 54, 93, 0.6); animation: spin 1.4s linear infinite; }
.loader-ring--2 { inset: 10%; border-top-color: rgba(56, 161, 105, 0.5); animation: spin 1s linear infinite reverse; }
.loader-ring--3 { inset: 20%; border-top-color: rgba(26, 54, 93, 0.35); animation: spin 0.7s linear infinite; }
.loader-core {
  position: absolute; inset: 32%; border-radius: 50%;
  background: linear-gradient(135deg, rgba(26, 54, 93, 0.12), rgba(56, 161, 105, 0.08));
  animation: corePulse 2s ease-in-out infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }
@keyframes corePulse { 0%, 100% { opacity: 0.5; transform: scale(0.92); } 50% { opacity: 1; transform: scale(1.05); } }

.loading-status { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #35506c; min-height: 22px; }
.loading-status__icon { color: #38a169; font-size: 16px; }

.loading-fade-enter-active, .loading-fade-leave-active { transition: opacity 0.3s ease, transform 0.3s ease; }
.loading-fade-enter, .loading-fade-leave-to { opacity: 0; transform: translateY(8px); }

.loading-progress { width: 100%; display: flex; flex-direction: column; gap: 6px; }
.loading-progress__bar { width: 100%; height: 5px; border-radius: 3px; background: rgba(26, 54, 93, 0.08); overflow: hidden; }
.loading-progress__fill { height: 100%; border-radius: 3px; background: linear-gradient(90deg, #1a365d, #38a169); transition: width 0.3s ease; }
.loading-progress__text { font-size: 12px; color: rgba(53, 80, 108, 0.5); text-align: right; }

.loading-error {
  width: 100%; text-align: center; padding: 16px; border-radius: 12px;
  background: rgba(245, 108, 108, 0.06); border: 1px solid rgba(245, 108, 108, 0.15);
}

.loading-error i { font-size: 28px; color: #f56c6c; }
.loading-error p { margin: 10px 0 14px; font-size: 14px; color: #606266; line-height: 1.6; }
.loading-error .el-button { border: none; border-radius: 10px; background: linear-gradient(90deg, #1a365d 0%, #38a169 100%); }
</style>
